import { classes } from 'html-classes';

import Icon from '../Icon/Icon';

export interface CarouselIconProps {
  onClick: () => void;
  position: 'right' | 'left';
  variant: 'fill' | 'white' | 'transparent';
  className?: string;
  hide?: boolean;
  iconClassName?: string;
  attributeName?: string;
  iconSize?: number;
}

const CarouselIcon = ({
  onClick,
  attributeName,
  position,
  variant,
  className,
  hide,
  iconClassName,
  iconSize = 24,
}: CarouselIconProps) => {
  if (hide) {
    return null;
  }

  return (
    <div
      data-button={attributeName}
      className={classes([
        `button-circle-arrow`,
        `_${position}`,
        `variant-${variant}`,
        className,
      ])}
      onClick={onClick}
    >
      <Icon type="chevron" size={iconSize} className={iconClassName} />
    </div>
  );
};

export default CarouselIcon;
